module.exports = __webpack_public_path__ + "static/media/cat.033161cb.png";